module.exports = __webpack_public_path__ + "static/img/2.dd455c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/2.png
// module id = 1v2g
// module chunks = 0